// Regla compartida de "¿está vencido / por vencer?" para documentos de cumplimiento
// (BranchDocument.expirationDate). Antes vivía duplicada e inline solo en SubirArchivos.jsx;
// UploadDocumentosDialog.jsx la reutiliza para mostrar el mismo badge de vencimiento.

export const EXPIRATION_ALERT_WINDOW_DAYS = 30;

/**
 * @param {string} expirationDateStr - fecha en formato ISO (YYYY-MM-DD) o con hora, o null/undefined.
 * @returns {{ isExpired: boolean, isNearExpiry: boolean }}
 */
export function getExpirationStatus(expirationDateStr) {
  if (!expirationDateStr) {
    return { isExpired: false, isNearExpiry: false };
  }
  // "Hoy" en fecha LOCAL, no UTC -- `toISOString()` siempre es UTC, y en huso horario de
  // México (UTC-6) eso adelanta el día hasta 6 horas antes de tiempo (18:00-23:59 local ya
  // cuentan como "mañana" en UTC), marcando documentos como vencidos antes de tiempo.
  const exp = expirationDateStr.substring(0, 10);
  const today = new Date().toLocaleDateString('en-CA');
  const nearDate = new Date(Date.now() + EXPIRATION_ALERT_WINDOW_DAYS * 86400000).toLocaleDateString('en-CA');

  const isExpired = exp < today;
  const isNearExpiry = !isExpired && exp <= nearDate;
  return { isExpired, isNearExpiry };
}
